import React from 'react';
import Header from '../common/header';

import Footer from '../common/footer';
import NewsPageHeader from '../layout/news/newsPageHeader';
import NewsPage from '../layout/news/news-content';




function News(){
    return(
        <>
        <Header/>
        
    
      <br/>
      <NewsPage></NewsPage>
        <br/>
        <Footer/>
        </>
    )
}
export default News;